module.exports = __webpack_public_path__ + "static/media/logo-viamais-login.0a8640d9.png";